'use strict';
const timestamp = require('timestamp');

class AuthenticationManager {
  constructor(requestConfigurationManager) {
    this.requestConfigurationManager = requestConfigurationManager;
  }

  requestAuthentication() {
    this.requestConfigurationManager.setApi('UserCredentials');

    const pathParams = [
      this.requestConfigurationManager.credentials.domain,
    ];
    const form = {
      resource: this.requestConfigurationManager.sdkConfiguration.PartnerServiceApiRoot,
      client_id: this.requestConfigurationManager.credentials.clientId,
      grant_type: 'password',
      username: this.requestConfigurationManager.credentials.userName,
      password: this.requestConfigurationManager.credentials.password,
      scope: 'openid',
    };

    const requestParams = {
      pathParams,
      form,
    };

    const options = this.requestConfigurationManager.getOptions(requestParams);
    return this.requestConfigurationManager.request(options);

  }

  tokenRefresh() {
    if (!this.getToken() || this.isExpired()) {
      return this.requestAuthentication().then((adToken) => {
        global.Token = adToken;
        return adToken.access_token;
      });
    }
    return Promise.resolve(global.Token.access_token);
  }

  /* eslint-disable class-methods-use-this */
  getToken() {
    if (global.Token) {
      return global.Token.access_token;
    }
  }

  isExpired() {
    return Number(timestamp().toString().substring(0, 10)) > global.Token.expires_on;
  }
}

module.exports = AuthenticationManager;
